import { ButtonOutlined } from '@components/common/Button/index.js';
import { Box } from '@styles/flexBox';
import { NavLink as RouterNavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const MenuActions = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;

export const LinkStyles = css`
  font-size: 16px;
  line-height: 24px;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: border-color 0.3s;
  color: var(--main-black);
  padding-bottom: 5px;
  cursor: pointer;

  &:hover {
    color: darkgray;
  }
`;

export const Link = styled.a`
  ${LinkStyles};

  ${(props) =>
    props.isLogOut &&
    css`
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
    `}

  ${(props) =>
    props.isMobileMenu &&
    css`
      color: #fff;
    `}

  ${(props) =>
    props.isDashboardMenu &&
    css`
      margin: 0;
      padding: 0;
    `}

  ${(props) =>
    props.isAccountMenu &&
    css`
      margin: 0;
      padding: 2px 0;
    `}
`;

export const NavLink = styled(RouterNavLink)`
  ${LinkStyles};

  &.${(props) => props.activeClassName} {
    color: #a05f83;
    border-color: #a05f83;
  }
`;

export const User = styled(Box)`
  padding-bottom: 5px;

  ${(props) =>
    props.isEmail &&
    css`
      cursor: pointer;
      overflow: hidden;
      max-width: 255px;
      text-overflow: ellipsis;

      display: flex;
      align-items: center;
    `}

  ${(props) =>
    props.isDashboardRoute &&
    css`
      max-width: 355px;
      font-size: 18px;
    `}

  ${(props) =>
    props.isShowingMobileMenu &&
    css`
      line-height: 24px;
    `}
`;

export const ErrorText = styled(Box)`
  color: var(--danger-text);
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 15px;
  text-align: left;

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${(props) =>
    props.isHide &&
    css`
      height: 19px;
      opacity: 0;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

export const Container = styled(Box)`
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.flex &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
    `}
  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
`;

export const FlexWrap = styled.div`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: ${(props) => props.justifyContent || 'flex-end'};
  align-items: ${(props) => props.alignItems || 'іstart'};

  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;

  @media (max-width: 767px) {
    display: flex;
    width: ${(props) => props.width || '78%'};
    flex-direction: row;
    justify-content: space-between;
  }

  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
      flex-shrink: 0;
      @media (max-width: 767px) {
        flex-direction: column;
        width: unset;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideTikTok &&
    css`
      @media (max-width: 768px) {
        align-items: center;
      }
    `}


  ${(props) =>
    props.insideLook &&
    css`
      @media (max-width: 767px) {
        justify-content: flex-end;
      }
    `}
  ${(props) =>
    props.isRelative &&
    css`
      position: relative;
    `}
`;

export const MobButtonWrap = styled.div`
  @media (max-width: 767px) {
    width: 48%;
    padding: 0;
    margin: 0;
  }

  ${(props) =>
    props.insideLinks &&
    css`
      @media (max-width: 767px) {
        width: 100%;
      }
    `}

  ${(props) =>
    props.isUpdatingMusic &&
    css`
      display: flex;
      justify-content: flex-end;
    `}

  ${(props) =>
    props.rightCorner &&
    css`
      margin-left: auto;
    `}

  ${(props) =>
    props.center &&
    css`
      display: flex;
      justify-content: center;
    `}
`;

export const DeleteImgMob = styled.img`
  max-height: 38px;

  ${(props) =>
    props.maxHeight &&
    css`
      max-height: ${props.maxHeight};
    `}
`;

export const ActionButtons = styled(Box)`
  display: flex;

  @media (max-width: 767px) {
    justify-content: center;
  }

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}

  ${(props) =>
    props.insideHeader &&
    css`
      padding-bottom: 30px;
    `}

  ${(props) =>
    props.insideLinks &&
    css`
      @media (max-width: 767px) {
        margin-top: 30px !important;
        margin-left: auto;
        width: 100px;
      }
    `}

  ${(props) =>
    props.insideSettings &&
    css`
      @media (max-width: 767px) {
        justify-content: space-between;
      }
    `}


  ${(props) =>
    props.insideTikTok &&
    css`
      @media (max-width: 767px) {
        justify-content: flex-start;
      }
    `}

  ${(props) =>
    props.insideMusic &&
    css`
      @media (max-width: 767px) {
        justify-content: flex-end;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.flexEnd &&
    css`
      justify-content: flex-end;

      @media (max-width: 767px) {
        justify-content: flex-end;
      }
    `}


  ${(props) =>
    props.customItems &&
    css`
      margin-top: 51px;
      margin-left: auto;
    `}

  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}
`;

export const MobButtonWrapDelete = styled.div`
  @media (max-width: 767px) {
    margin-right: 24px;
    width: 18%;
    line-height: 1.4em;
    padding: 0;
  }
`;

export const Subcaption = styled(Box)`
  display: inline;

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
    ${(props) =>
    props.mailingDesc &&
    css`
      font-size: 12px;
      color: var(--secondary-gray);
      flex-deirection: column;
      @media (max-width: 650px) {
        margin-top: 10px;
        padding: 10px 0 0 0;
      }
    `}
`;

export const InputBlockBox = styled(Box)`
  position: relative;

  ${(props) =>
    props.notifsEmail &&
    css`
      align-items: center;
      display: flex;
    `}

  ${(props) =>
    props.isSectionSettings &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const InputBlockChangeLink = styled(Box)`
  display: flex;
  align-items: flex-end;
  margin: 0 0 3px 30px;
  color: #007aff;
  cursor: pointer;
  text-decoration: underline;

  ${(props) =>
    props.notification &&
    css`
      margin: 0;
      margin-left: auto;
    `}
  ${(props) =>
    props.notification &&
    css`
      align-items: center;
    `}
`;

export const InputIcon = styled.img`
  position: absolute;
  top: 6px;
  left: 10px;
  width: 30px;
  height: 30px;

  ${(props) =>
    props.gmailIcon &&
    css`
      top: 9px;
      left: 12px;
      width: 25px;
      height: 25px;
    `}

  ${(props) =>
    props.selzyIcon &&
    css`
      width: 30px;
      height: 30px;
      top: 5px;
      left: 5px;
    `}
`;

export const InputIconBox = styled(Box)`
  position: absolute;
  top: 6px;
  left: 10px;
  width: 30px;
  height: 30px;

  ${(props) =>
    props.isInsideMigrate &&
    css`
      transform: rotate(-45deg);
    `}

  ${(props) =>
    props.isInsideLook &&
    css`
      width: 14px;
      height: 14px;
      position: relative;
      top: -4px;
      left: 2px;
    `}
`;

// <!-- start copy of Post.js
export const TextareaBox = styled(Box)`
  position: relative;
  width: 100%;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const EmojiPickerWrap = styled(Box)`
  position: fixed;
  right: -9999px;
  z-index: 1000;
  transition: opacity 0.2s;
  opacity: 0;
  overflow: hidden;

  ${(props) =>
    props.visible &&
    css`
      position: absolute;
      opacity: 1;
      overflow: visible;

      @media (max-width: 992px) {
        top: 0;
        right: 0;
      }

      @media (min-width: 993px) {
        top: -110px;
        right: -40px;
      }
    `}
`;
// <!-- end copy of Post.js

export const CustomSpan = styled.span`
  ${(props) =>
    props.addProduct &&
    css`
      font-size: 20px;
      margin-right: 5px;
      color: #fff;
    `}
`;

export const DeleteBlackImg = styled.img`
  height: 24px;
  display: block;

  ${(props) =>
    props.deleteTag &&
    css`
      height: 16px;
    `}
`;

export const ActionButton = styled(ButtonOutlined)`
  display: inline-flex;
  width: 48%;
  margin: 0 0 10px;
  padding: 0 10px;
  align-items: center;
  text-align: left;
  font-weight: 700;
  font-size: 14px;
  color: var(--text-tertiary);
  background: #f8f8f8;
  border: 1px solid #f8f8f8;

  &:hover {
    color: #489be0;
    border: 1px solid #489be0;
  }

  &:disabled {
    &:hover {
      color: var(--secondary-gray);
      background: var(--main-gray);
      border: 1px solid #eeeff1;
    }
  }

  ${(props) =>
    props.active &&
    css`
      background: #489be0;
      border: 1px solid #489be0;
      color: #fff;

      &:hover {
        color: #fff;
        border: 1px solid #489be0;
        background: #489be0;
      }
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};

      @media (max-width: 767px) {
        width: 100%;
      }
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.small &&
    css`
      min-height: 32px;
      max-height: 32px;
      line-height: 32px;
    `}


  ${(props) =>
    props.uploadTagImage &&
    css`
      width: auto;
    `}

  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}
`;

export const ActionButtonIcon = styled.span`
  width: 30px;
  margin-right: 10px;

  @media (max-width: 767px) {
    margin-left: 10px;
  }

  ${(props) =>
    props.marginRight &&
    css`
      margin-right: ${props.marginRight};
    `}
`;

export const ActionButtonIconImg = styled.img`
  display: block;
  max-width: 100%;
  margin: 0 auto;
`;

export const AddedMark = styled(Box)`
  min-width: 60px;
  text-align: center;
  padding: 5px 10px;
  background: #17ce17;
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: white;
  border-radius: 12px;
  font-size: 13px;

  ${(props) =>
    !props.isHide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.tikTokItem &&
    css`
      bottom: 20px;

      @media (max-width: 567px) {
        bottom: 10px;
      }
    `}
`;

export const Checkmark = styled.span`
  position: absolute;
  top: -3px;
  left: 0;
  height: 24px;
  width: 24px;
  background-color: transparent;
  border: 1px solid var(--border-color);
  border-radius: 5px;

  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 7px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  ${(props) =>
    props.disabled &&
    css`
      cursor: default;
      opacity: 0.5;
      background-color: var(--overlay-light);
    `}

  ${(props) =>
    props.topCheckMark &&
    css`
      top: ${props.topCheckMark};
    `}
`;

export const RadioCheckmark = styled.span`
  flex: none;
  position: absolute;
  top: -3px;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: transparent;
  border: 2px solid var(--border-color);
  border-radius: 50%;

  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 7px;
    top: 3px;
    width: 1px;
    height: 1px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  ${(props) =>
    props.notAbsolute &&
    css`
      position: relative;
      top: 0;
      left: 0;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.emailCollect &&
    css`
      display: inline-flex;
      margin: 0 10px 0 0;
    `}

  ${({ size }) =>
    size &&
    css`
      width: ${size};
      height: ${size};
    `}
`;

export const QuestionBox = styled(Box)`
  margin-left: 12px;
  cursor: pointer;

  ${(props) =>
    props.inline &&
    css`
      display: inline;
    `}

  ${(props) =>
    props.relativeTooltip &&
    css`
      position: relative;
      z-index: 100;
    `}
`;

export const TimerList = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const TimerItem = styled(Box)`
  width: 48%;

  @media (max-width: 768px) {
    width: 100%;
  }

  ${(props) =>
    props.timerType &&
    css`
      @media (max-width: 768px) {
        margin-top: 16px;
      }
    `}
`;

export const TimerIcon = styled.img`
  margin-right: 8px;
  width: 30px;
  height: 30px;
`;

export const ProPlanSettingsBox = styled.div`
  position: relative;
  width: 100%;

  ${(props) =>
    props.position &&
    css`
      position: ${props.position};
    `}
  ${(props) =>
    props.isBigTemplates &&
    css`
      height: 100%;
    `}
`;

export const ProPlanSettings = styled.div`
  ${(props) =>
    props.isNotPro &&
    css`
      pointer-events: none;
      opacity: 0.3;
      user-select: none;
      cursor: not-allowed;

      button,
      a,
      div {
        pointer-events: none !important;
      }
    `}
  ${(props) =>
    props.isBigTemplates &&
    css`
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    `}
`;

export const GetProPlanSettings = styled(Box)`
  //position: absolute;
  //top: 50%;
  position: absolute;
  top: 350px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props) =>
    props.top &&
    css`
      top: ${props.top};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.messenger &&
    css`
      top: 400px;

      @media (min-width: 568px) and (max-width: 992px) {
        top: 440px;
      }
    `}
`;

export const GetProPlanIcon = styled.img`
  width: 75px;
  height: 85px;
`;

export const AudienceContainer = styled(Box)`
  padding: 0 3rem;

  @media (max-width: 768px) {
    margin: 18px 0 28px 0;
  }

  @media (max-width: 568px) {
    position: relative;
    margin: 40px 0 28px 0;
  }
  @media (max-width: 480px) {
    position: relative;
    margin: 0 0 28px 0;
    padding: 0 0 80px;
  }
`;

export const CustomFormCheckboxList = styled(Box)`
  display: flex;

  ${(props) =>
    props.insideForm &&
    css`
      position: relative;
      margin-top: 15px;
      flex-direction: column;

      &:before {
        content: 'Required';
        position: absolute;
        top: -24px;
        right: 0;
        font-size: 13px;
        color: var(--secondary-gray);
      }
    `}

  ${(props) =>
    props.insideForm &&
    props.required &&
    css`
      position: relative;
      margin-top: 15px;
      flex-direction: column;

      &:before {
        content: '${props.required || "Обов'язково"}'; /* в лапках! */
        position: absolute;
        top: -24px;
        right: 0;
        font-size: 13px;
        color: var(--secondary-gray);
      }
    `}

  ${(props) =>
    props.insideShop &&
    css`
      justify-content: space-between;

      @media (max-width: 768px) {
        justify-content: space-between;
        flex-wrap: wrap;
      }
    `}
`;

export const IconsCheckboxList = styled(Box)`
  display: flex;
  justify-content: space-between;

  ${(props) =>
    props.insideShop &&
    css`
      margin-bottom: 30px;
      justify-content: flex-start;
      flex-direction: column;
    `}
`;

export const IconsCheckboxItem = styled(Box)`
  padding: 3px;
  border-radius: 6px;
  border: 3px solid #f1f1f1;

  width: 32%;
  display: flex;
  justify-content: space-between;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideShop &&
    css`
      justify-content: flex-start;
      width: 285px;
      margin-bottom: 10px;
    `}
`;

export const IconsCheckboxIconBox = styled(Box)`
  background-color: var(--surface-elevated);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;

  ${(props) =>
    props.insideShop &&
    css`
      flex: none;
    `}
`;

export const CustomFormAddField = styled(Box)`
  margin: 25px 0 25px 13px;
  color: #4e75fe;
  cursor: pointer;
`;

export const CustomFormFieldBox = styled(Box)`
  padding: 20px 0 20px 15px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e8;

  ${(props) =>
    props.noBorder &&
    css`
      border-bottom: none;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
`;

export const CustomFormFieldTitle = styled(Box)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 150px;

  ${(props) =>
    props.customField &&
    css`
      cursor: pointer;
    `}
`;

export const CustomFormCheckboxItem = styled(Box)`
  width: 33%;

  ${(props) =>
    props.insideForm &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.widthMobile &&
    css`
      @media (max-width: 768px) {
        width: ${props.widthMobile};
      }
    `}

  ${(props) =>
    props.emailCollect &&
    css`
      margin: 20px 0;
      display: flex;
      align-items: center;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const CurrencyLangBox = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const CurrencyBox = styled(Box)`
  width: 48%;
`;

export const DropDownBox = styled(Box)`
  width: 48%;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideBio &&
    css`
      @media (max-width: 1300px) {
        width: 22%;
      }

      @media (max-width: 768px) {
        width: 33%;
      }
    `}

  ${(props) =>
    props.timerStyles &&
    css`
      @media (max-width: 768px) {
        width: 100%;
      }
    `}
`;

export const LangBox = styled(Box)`
  width: 48%;

  @media (max-width: 568px) {
    width: 100%;
  }

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

export const ExtractButtonBox = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const ExtractButtonInput = styled(Box)`
  @media (max-width: 768px) {
    width: 65%;
  }
`;

export const ExtractButton = styled(Box)`
  margin-top: 22px;

  @media (max-width: 768px) {
    width: 30%;
    margin-top: 26px;
  }
`;

export const ExtractButtonIcon = styled.img`
  margin-left: 10px;
  width: 15px;
  height: 15px;

  ${(props) =>
    props.buttonLink &&
    css`
      margin: 0;

      @media (max-width: 568px) {
        margin: 0 10px;
      }
    `}
`;

export const PostDisplayBox = styled(Box)`
  margin: 8px 0 22px;
  position: relative;
  z-index: 2;
  width: 80%;

  @media (max-width: 568px) {
    width: 100%;
  }
`;

export const UserContactList = styled(Box)`
  display: flex;
  margin: 0 auto;
  width: 100%;

  ${(props) =>
    props.isSupport &&
    css`
      flex-direction: column;
      padding: 20px 0;
    `}
`;

export const UserContactItemLink = styled.a`
  position: relative;
  padding: 5px;
  flex-basis: 50%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 14px;
  text-decoration: none;

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  &:only-child {
    flex-basis: 100%;
  }

  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
    `}

  ${(props) =>
    props.center &&
    css`
      justify-content: center;
      align-items: center;
    `}

 ${(props) =>
    props.directMessage &&
    css`
      &:last-child {
        margin-right: 0;
      }
    `}

  &:not&:first-child {
    margin-right: 10px;
  }

  ${(props) =>
    props.isSupport &&
    css`
      margin: 0 0 15px 0;
      cursor: pointer;
      height: 50px;
      flex: none;
      font-size: 16px;
    `}
`;

export const UserContactIcon = styled.img`
  width: 35px;
  height: 35px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.absolute &&
    css`
      position: absolute;
      top: 8px;
      left: 20px;
    `}
`;

export const UserContactTitle = styled.span`
  color: #fff;
  ${(props) => props.color && `color: ${props.color};`}
`;

export const PropertiesHeading = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isSettings &&
    css`
      line-height: 27px;
    `}
`;

export const PropertiesList = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
`;

export const LabelsList = styled(Box)`
  margin-left: 10px;
  display: flex;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isWrap &&
    css`
      flex-wrap: wrap;
    `}

  ${(props) =>
    props.isAbsolute &&
    css`
      position: absolute;
      flex-direction: column;
      top: 10px;
      right: 10px;
    `}
  ${(props) =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex};
    `}
`;

export const PropertiesItem = styled(Box)`
  margin-right: 8px;
  margin-bottom: 8px;
  cursor: pointer;

  ${(props) =>
    props.string &&
    css`
      font-size: 13px;
      padding: 6px 12px;
      height: 32px;
      display: inline-flex;
      align-items: center;
      border-radius: 8px;
      border: 1px solid #e0e2e9;
      background: #fff;
      color: #191d3a;
      transition:
        border-color 120ms ease,
        background 120ms ease;

      &:hover {
        border-color: #c9cdd6;
        background: #f6f7f9;
      }
    `}

  ${(props) =>
    props.color &&
    css`
      min-width: 28px;
      width: 28px;
      height: 28px;
      background: ${props.background};
      border-radius: 8px;
      border: 1px solid ${props.background === 'white' || props.background === '#fff' || props.background === '#ffffff' ? '#E0E2E9;' : props.background};
    `}



  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideMediaColor &&
    css`
      margin: 0;
    `}


  ${(props) =>
    props.insideMediaColor &&
    css`
      height: 20px;
      width: 20px;
      max-width: 20px;
      min-width: initial;
      margin: 0;
      padding: 0;
      border-radius: 50%;
    `}

  ${(props) =>
    props.insideMediaString &&
    css`
      margin: 0;
      padding: 0;
      border: none;
      height: initial;
    `}


  ${(props) =>
    props.label &&
    css`
      display: flex;
      align-items: center;
      padding: 5px 10px;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: bold;
      border-radius: 36px;
      border: 1px solid var(--border-color);
    `}

  ${(props) =>
    props.backgroundColor &&
    css`
      background: ${props.backgroundColor};
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.labelItem &&
    css`
      padding: 0 10px;
      width: auto;
      min-width: initial;
      max-width: initial;
      text-transform: uppercase;
      font-weight: bold;
      border-radius: 36px;
    `}

  ${(props) =>
    props.activeColor &&
    css`
      position: relative;
      border: 3px #17ce17 solid;

      &:before {
        position: absolute;
        top: -9px;
        right: -9px;
        content: '';
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #17ce17;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;opacity:0;%7D.cls-2%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Echeckmark%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='checkmark'%3E%3Cg id='checkmark-2' data-name='checkmark'%3E%3Crect class='cls-1' width='24' height='24'/%3E%3Cpath class='cls-2' d='M9.86,18a1,1,0,0,1-.73-.32L4.27,12.51a1,1,0,1,1,1.46-1.37l4.12,4.39,8.41-9.2a1,1,0,1,1,1.48,1.34l-9.14,10a1,1,0,0,1-.73.33Z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      }
    `}

  ${(props) =>
    props.activeString &&
    css`
      position: relative;
      border: 1px #17ce17 solid;

      &:before {
        position: absolute;
        top: -9px;
        right: -9px;
        content: '';
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #17ce17;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;opacity:0;%7D.cls-2%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Echeckmark%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='checkmark'%3E%3Cg id='checkmark-2' data-name='checkmark'%3E%3Crect class='cls-1' width='24' height='24'/%3E%3Cpath class='cls-2' d='M9.86,18a1,1,0,0,1-.73-.32L4.27,12.51a1,1,0,1,1,1.46-1.37l4.12,4.39,8.41-9.2a1,1,0,1,1,1.48,1.34l-9.14,10a1,1,0,0,1-.73.33Z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      }
    `}

  ${(props) =>
    props.digital &&
    css`
      margin-left: 0;
      margin-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 10px;
      height: 25px;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  ${(props) =>
    props.isAbsolute &&
    css`
      margin-bottom: 10px !important;
    `}

    ${(props) =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth};
      text-align: center;
      display: block;
    `}
    ${(props) =>
    props.lineHeight &&
    css`
      line-height: ${props.lineHeight};
    `}
`;

export const FlexBox = styled(Box)`
  display: flex;

  ${(props) =>
    props.center &&
    css`
      justify-content: center;
      align-items: center;
    `}
  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
    `}
  ${(props) =>
    props.alignItems &&
    css`
      align-items: ${props.alignItems};
    `}
  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.gap &&
    css`
      gap: ${props.gap};
    `}
  ${(props) =>
    props.wrap &&
    css`
      flex-wrap: ${props.wrap};
    `}
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
  ${(props) =>
    props.relative &&
    css`
      position: relative;
    `}
`;

export const InputAutofillItem = styled(Box)`
  // display: flex;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.linkType &&
    css`
      flex: none;
    `}

  ${(props) =>
    props.downloadLink &&
    css`
      width: 90px;
    `}

  ${(props) =>
    props.appointment &&
    css`
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
    `}

  ${({ soon }) =>
    soon &&
    css`
      background-color: rgb(255, 169, 0);
      color: rgb(255, 255, 255);
      border-radius: 12px;
      text-transform: uppercase;
      text-align: center;
      font-size: 12px;
      padding: 4px 5px;
      width: 12%;
    `}
`;

export const SubpageItemEditBox = styled(Box)`
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  width: 30px;
  height: 30px;

  justify-content: center;
  align-items: center;
`;

export const SubpageItemEditCover = styled(Box)`
  background: linear-gradient(0deg, #00000066, #00000066);
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;

export const SubpageItemPreview = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
`;

export const SettingsBox = styled(Box)`
  ${(props) =>
    props.margin &&
    css`
      width: ${props.margin};
    `}
`;

export const SettingsLink = styled(Box)`
  margin-top: 10px;
  font-size: 14px;
  color: #007aff;
  cursor: pointer;
`;

export const SettingsBoxItem = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const SpinnerContainer = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  background: var(--main-background);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const SpinnerBox = styled(Box)`
  margin-left: 8px;
`;

export const FaqList = styled(Box)`
  margin: -20px 0 30px;
`;

export const Footer = styled(Box)`
  padding: 0 10px;
`;

export const List = styled(Box)`
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.fixHeight &&
    css`
      height: ${props.fixHeight}px;
    `}

  ${(props) =>
    props.flex &&
    css`
      display: flex;
      justify-content: space-between;
    `}

  ${(props) =>
    props.isFlex &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.subscribe &&
    css`
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
    `}

  ${(props) =>
    props.isHeader &&
    css`
      @media (max-width: 1350px) {
        flex-wrap: wrap;
      }
    `}

  ${(props) =>
    props.isHeaderButtons &&
    css`
      @media (max-width: 576px) {
        flex-direction: column;
        gap: 20px;
      }
    `}
`;

export const ListItem = styled(Box)`
  width: 33%;
`;

export const MainSection = styled(Box)`
  display: block;
  ${({ hide }) =>
    hide &&
    css`
      display: none;
    `}
`;

export const SplashScreenContent = styled(Box)`
  margin-bottom: 100px;

  ${(props) =>
    props.isChooseProduct &&
    css`
      margin-bottom: 43px;
    `}
`;

export const SplashScreenText = styled(Box)`
  margin-bottom: 10px;
  font-size: 15px;

  ${(props) =>
    props.isWarning &&
    css`
      font-weight: bold;
      color: red;
    `}
`;

export const SplashScreenLink = styled(Box)`
  text-decoration: underline;
  font-size: 15px;
  color: #1f3fff;
  cursor: pointer;

  ${(props) =>
    props.isWarning &&
    css`
      color: #0b67c8;
      font-weight: bold;
    `}
`;

export const ComponentBox = styled(Box)`
  ${(props) =>
    props.isMarginBottom &&
    css`
      margin-bottom: 137px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const InputRadioTitle = styled(Box)`
  margin-left: 15px;
`;

export const InputBox = styled(Box)`
  display: flex;
  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
`;

export const Wrapper = styled(Box)`
  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `};
  ${({ position }) =>
    position &&
    css`
      position: ${position};
      z-index: 100;
    `};
`;

export const SettingLink = styled(Box)`
  cursor: pointer;
  font-size: 14px;
  color: #4e75fe;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const SettingsList = styled(Box)`
  display: flex;

  @media (max-width: 568px) {
    margin-top: 10px;
    justify-content: space-between;
  }

  ${(props) =>
    props.downloads &&
    css`
      //position: absolute;
      display: inline-flex;
      margin-left: auto;
      right: 20px;
      top: 18px;
      z-index: 100;

      @media (max-width: 768px) {
        position: static;
      }
    `}

  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        margin-top: 0;
        margin-left: 0;
      }
    `}
`;

export const Header = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  overflow: hidden;

  @media (max-width: 568px) {
    flex-direction: column;
  }

  ${(props) =>
    props.downloads &&
    css`
      margin: 0;
      align-items: center;
    `}
  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
        overflow: visible;
      }
    `}

  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}
`;

export const SettingsItem = styled(Box)`
  display: flex;
  align-items: center;
  padding: 10px 10px 10px 15px;
  cursor: pointer;
  font-size: 13px;

  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        height: 42px;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

    ${(props) =>
    props.responses &&
    css`
      height: 32px;
      padding: 6px 12px 6px 8px;
      border-radius: 8px;
      box-shadow:
        0 0 0 1px rgba(204, 204, 204, 0),
        0px 0px 0px 1px rgba(0, 0, 0, 0.04),
        0px 1px 4px 0px rgba(0, 0, 0, 0.12);

      &:hover {
        background-color: var(--subtle-background);
      }
    `}

    ${(props) =>
    props.audience &&
    css`
      width: 260px;
      padding: 8px;

      &:hover {
        background: unset;
      }
    `}
`;

export const SettingsIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 10px;

  [data-theme='dark'] & {
    filter: invert(1);
  }

  ${(props) =>
    props.loupe &&
    css`
      width: 17px;
      height: 17px;
      margin-right: 0;
    `}

  ${(props) =>
    props.close &&
    css`
      margin-right: 0;
    `}
`;
